import { render, staticRenderFns } from "./viewbigpictures.vue?vue&type=template&id=a06b71fe&scoped=true"
import script from "./viewbigpictures.vue?vue&type=script&lang=js"
export * from "./viewbigpictures.vue?vue&type=script&lang=js"
import style0 from "./viewbigpictures.vue?vue&type=style&index=0&id=a06b71fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06b71fe",
  null
  
)

export default component.exports